import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { Slider } from "@mui/material";
import React, { useEffect, useState } from "react";

import { getTransactionByHash } from "../../libs/aptos_sdk";
import { Pool, getPool } from "../../libs/pool";
import {
  get_coin_icon,
  get_coin_short_name,
  get_coin_xy_supply,
  get_lp_coin_balance_no_decimals,
  remove_liquidity,
} from "../../libs/swap_sdk";
import { useAppSelector } from "../../store/hooks";
import { sleep } from "../../utils/common";
import Button from "../Common/Button";
import TransactionDialog from "../Common/TransactionDialog";
import Divider from "../Divider";
type Props = {
  coinX: string;
  coinY: string;
  slippageRate: string;
};

const WithdrawTab: React.FC<Props> = (props: Props) => {
  const { coinX, coinY, slippageRate } = props;
  const accountAddresses = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );
  const { signAndSubmitTransaction } = useWallet();

  const coinInfoIconX = get_coin_icon(coinX);
  const coinInfoIconY = get_coin_icon(coinY);
  const [withdrawText, setWithdrawText] = useState("Insufficient balance");
  const [withdrawRate, setWithdrawRate] = useState<number>(0);
  const [balanceXY, setBalanceXY] = useState<number>(0);
  const [supplyXY, setSupplyXY] = useState(0);
  const [amountWithdrawX, setAmountWithdrawX] = useState<string>("0");
  const [amountWithdrawY, setAmountWithdrawY] = useState<string>("0");
  const [amountMaxWithdrawX, setAmountMaxWithdrawX] = useState<string>("0");
  const [amountMaxWithdrawY, setAmountMaxWithdrawY] = useState<string>("0");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [step, setStep] = useState(0);
  const [txn, setTxn] = useState("");
  const [pool, setPool] = useState<Pool>();
  const lp_decimals = 8; // stacialy

  useEffect(() => {
    const fetch = async () => {
      if (coinX && coinY) {
        const data = await getPool(coinX, coinY);
        if (data) setPool(data);
      }
    };
    fetch();
    // const timer = setInterval(fetch, 10 * 1000);
    // return () => {
    //   clearInterval(timer);
    // };
  }, [coinX, coinY]);

  useEffect(() => {
    if (withdrawRate <= 0) {
      setWithdrawText("Insufficient balance");
    } else {
      setWithdrawText("Withdraw");
    }
  }, [withdrawRate]);

  useEffect(() => {
    const get = async () => {
      if (!pool) return;
      //no decimals
      const coin_info_supply = await get_coin_xy_supply(coinX, coinY);
      if (coin_info_supply > 0) {
        setSupplyXY(coin_info_supply);
        if (balanceXY > 0) {
          setAmountMaxWithdrawX(
            (
              (Number(pool.reserve_x) * balanceXY) /
              (Math.pow(10, pool.x_coin_info.decimals) * coin_info_supply)
            ).toFixed(4)
          );
          setAmountMaxWithdrawY(
            (
              (Number(pool.reserve_y) * balanceXY) /
              (Math.pow(10, pool.y_coin_info.decimals) * coin_info_supply)
            ).toFixed(4)
          );
        }
      }
    };
    get();
    const timer = setInterval(get, 30000);
    return () => {
      clearInterval(timer);
    };
  }, [pool, coinX, coinY, balanceXY]);

  useEffect(() => {
    const get = async () => {
      const amountXY = await get_lp_coin_balance_no_decimals(
        accountAddresses,
        coinX,
        coinY
      );
      if (amountXY > 0) {
        setBalanceXY(amountXY);
      }
    };
    get();

    const timer = setInterval(get, 17500);
    return () => {
      clearInterval(timer);
    };
  }, [accountAddresses, coinX, coinY]);

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    if (!pool) return;
    if (Array.isArray(newValue)) {
      return;
    }
    setWithdrawRate(newValue);

    // const share = newValue * Math.pow(10, lp_decimals)/supplyXY;
    setAmountWithdrawX(
      (
        (Number(pool.reserve_x) *
          newValue *
          Math.pow(10, lp_decimals - pool.x_coin_info.decimals)) /
        supplyXY
      ).toFixed(6)
    );
    setAmountWithdrawY(
      (
        (Number(pool.reserve_y) *
          newValue *
          Math.pow(10, lp_decimals - pool.y_coin_info.decimals)) /
        supplyXY
      ).toFixed(6)
    );
  };
  const handleCloseAlert = () => setOpenAlert(false);
  const handleWithdraw = async () => {
    if (!pool) return;
    setOpenAlert(true);
    setTxn("");
    setStep(0);
    const lp_amount1 = withdrawRate * Math.pow(10, lp_decimals);
    const share = lp_amount1 / supplyXY;
    const x_amount1 = Number(pool.reserve_x) * share;
    const y_amount1 = Number(pool.reserve_y) * share;
    const x_amount1_min = parseInt(
      (x_amount1 * (1 - Number(slippageRate) / 100)).toFixed(),
      10
    );
    const y_amount1_min = parseInt(
      (y_amount1 * (1 - Number(slippageRate) / 100)).toFixed(),
      10
    );
    const data = await remove_liquidity(
      signAndSubmitTransaction,
      coinX,
      coinY,
      lp_amount1,
      x_amount1_min,
      y_amount1_min
    );

    setTxn(data.hash);

    setStep(1);
    let transaction;
    while (!transaction) {
      try {
        transaction = await getTransactionByHash(data.hash);
        window.console.info("transaction", transaction);
      } catch (e) {
        await sleep(500);
        window.console.error(e);
      }
    }
    setStep(2);
  };

  return (
    <>
      <div className="p-4">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-3">
            <div className="text-white text-opacity-50">
              {" "}
              Select the percentage of your position to withdraw:
            </div>
            <div className="flex items-center gap-8">
              <div className="flex w-1/4">
                <p className="text-white text-opacity-50 bg-white bg-opacity-20 rounded-lg p-2">
                  {(
                    (Number(withdrawRate) * 100) /
                    Number(balanceXY / Math.pow(10, lp_decimals))
                  ).toFixed(1)}
                  % = {withdrawRate}
                </p>
              </div>
              <div className="w-full">
                <Slider
                  step={0.00000001}
                  onChange={handleSliderChange}
                  max={Number(balanceXY / Math.pow(10, lp_decimals))}
                  value={withdrawRate}
                  defaultValue={0}
                  aria-label="Default"
                  valueLabelDisplay="auto"
                />
              </div>
            </div>
          </div>
          <Divider padding={3} />

          <div className="flex justify-between items-start bg-primary-100 rounded-lg p-2">
            <div className="flex flex-col justify-end items-end">
              <p className="text-white text-4xl">{amountWithdrawX}</p>
              {/* <p className="text-white">$: --</p> */}
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="flex items-center gap-2 bg-primary-200 rounded-full p-2">
                <img alt="Coin" className="w-6 h-6" src={coinInfoIconX.icon} />
                <span className="text-white text-[15px] font-semibold">
                  {get_coin_short_name(coinX)}
                </span>
              </div>
              <div className="text-white text-opacity-50">
                Max Withdrawal: : {amountMaxWithdrawX}
              </div>
            </div>
          </div>
          <Divider padding={3} />
          <div className="flex justify-between items-start bg-primary-100 rounded-lg p-2">
            <div className="flex flex-col justify-end items-end">
              <p className="text-white text-4xl">{amountWithdrawY}</p>
              {/* <p className="text-white">$: --</p> */}
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="flex items-center gap-2 bg-primary-200 rounded-full p-2">
                <img alt="Coin" className="w-6 h-6" src={coinInfoIconY.icon} />
                <span className="text-white text-[15px] font-semibold">
                  {get_coin_short_name(coinY)}
                </span>
              </div>
              <div className="text-white text-opacity-50">
                Max Withdrawal: : {amountMaxWithdrawY}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4">
        <Button
          fullWidth
          onClick={handleWithdraw}
          disabled={withdrawText !== "Withdraw"}
          variant="contained"
        >
          {withdrawText}
        </Button>
      </div>

      <div>
        <TransactionDialog
          openAlert={openAlert}
          txn={txn}
          title=""
          step={step}
          handleCloseAlert={handleCloseAlert}
        />
      </div>
    </>
  );
};

export default React.memo(WithdrawTab);
